
export const SAT_BASE_URL = "https://www.n2yo.com/rest/v1/satellite";

export const SAT_API_KEY = "7KXWJ4-TPKNYM-HPPVM9-4IBC";

export const STARLINK_CATEGORY = "52";

export const NEARBY_SATELLITE = `${SAT_BASE_URL}/above`;

export const WORLD_MAP_URL = "https://unpkg.com/world-atlas@1/world/110m.json";

export const SATELLITE_POSITION_URL = `${SAT_BASE_URL}/positions`;
